import { Modal, Row, Spin } from 'antd';
import React, { useEffect, useMemo } from 'react';
import { Document, Page } from 'react-pdf';
import { ModalTitle } from '../../components/text/Titles';
import { MatchingEntity, DocumentReference } from '../../types';
import { FailedToLoadPage } from '../splitter/components';

const WIDTH = 500;
const HEIGHT = 700;

type Props = {
  detailMatching: { entity: MatchingEntity; page: number };
  documents: DocumentReference[];
  onCancel: () => void;
  numPages: { source: number; match: number };
};

export const MatchingDetailView = ({ detailMatching, onCancel, numPages, documents }: Props) => {
  const pageRefs = useMemo(() => {
    return detailMatching.entity.content?.reduce((acc: any, value) => {
      acc[value.source_page as keyof {}] = React.createRef();
      return acc;
    }, {});
  }, [detailMatching.entity.content]);

  useEffect(() => {
    if (detailMatching.page && pageRefs) {
      console.log(pageRefs);
      setTimeout(() => {
        pageRefs[detailMatching.page].current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 1000);
    }
  }, [detailMatching.page, pageRefs]);

  return (
    <Modal
      width={1200}
      style={{ top: '50px' }}
      visible={detailMatching !== null}
      title={
        <ModalTitle>
          {detailMatching.entity.id} compared with {detailMatching.entity.match_id}
        </ModalTitle>
      }
      onCancel={onCancel}
      footer={null}>
      <div style={{ padding: '2em', paddingBottom: '0em', background: '#f0f2f5', minHeight: '500px' }}>
        {detailMatching.entity.content.map(pageMatch => {
          return (
            <Row
              key={pageMatch.source_page}
              ref={pageRefs[pageMatch.source_page]}
              className="justify-between pb-4 mb-6"
              style={{ borderBottom: '1px solid #ccc', minHeight: HEIGHT }}>
              <p style={{ fontWeight: 'bold', fontSize: '22px' }}>{pageMatch.source_page}</p>
              <div style={{ width: WIDTH }} className="flex justify-center items-center">
                <Document
                  file={documents.find(file => file.id === detailMatching.entity.id)?.pdf}
                  loading={<Spin />}
                  className={'flex justify-center items-center h-full pointer-events-none'}>
                  {numPages.source > 0 ? (
                    <Page
                      className={'border border-solid border-gray-400'}
                      height={HEIGHT}
                      width={WIDTH}
                      pageNumber={pageMatch.source_page}
                      error={<FailedToLoadPage width={WIDTH} height={HEIGHT} />}
                    />
                  ) : null}
                </Document>
              </div>
              <div className="flex justify-center items-center" style={{ width: WIDTH }}>
                {pageMatch.match_page ? (
                  <Document
                    file={documents.find(file => file.id === detailMatching.entity.match_id)?.pdf}
                    loading={<Spin />}
                    className={'flex justify-center items-center h-full pointer-events-none'}>
                    {numPages.source > 0 ? (
                      <Page
                        className={'border border-solid border-gray-400'}
                        height={HEIGHT}
                        width={WIDTH}
                        pageNumber={pageMatch.match_page}
                        error={<FailedToLoadPage width={WIDTH} height={HEIGHT} />}
                      />
                    ) : null}
                  </Document>
                ) : (
                  <div style={{ textAlign: 'center' }}>No matching page found</div>
                )}
              </div>
            </Row>
          );
        })}
      </div>
    </Modal>
  );
};
